import {
  HStack,
  Button,
} from "@chakra-ui/react";

import { useTranslation } from "react-i18next";

export default function LanguageStack() {
  const { i18n } = useTranslation();

  return (
    <HStack>
      <Button
        size="sm"
        borderRadius="full"
        onClick={() => i18n.changeLanguage("id")}
        opacity={i18n.language === "id" ? 1 : 0.5}
      >
        🇮🇩
      </Button>

      <Button
        size="sm"
        borderRadius="full"
        onClick={() => i18n.changeLanguage("en")}
        opacity={i18n.language === "en" ? 1 : 0.5}
      >
        🇺🇸
      </Button>
    </HStack>
  );
}